import { Pipe, PipeTransform } from '@angular/core';
import { EnumUtilities } from '../../utilities/enum.utilities';

@Pipe({
  name: 'formatLabel'
})
export class FormatLabelPipe<T extends string | number> implements PipeTransform {

  transform(value: T): string {
    return EnumUtilities.convertToLabel(value.toString());
  }

}
